import React, { forwardRef } from "react";
import styled from "styled-components";
import { CreateFormTheme, Theme } from "../../../utils/themes";
import { LayoutWidget } from "../../contacts/ContactOverview/DND/dndTypes";
import GridStackExample, { GridStackHandle } from "../../contacts/ContactOverview/DND/GridStackExample";

interface OrganizationOverviewProps {
  organization?: any;
  editingPhase: boolean;
  loading?: boolean;
  refetch: () => void;
  widget: LayoutWidget[];
  setWidget: React.Dispatch<React.SetStateAction<LayoutWidget[]>>;
  isManagingLayout?: boolean;
  backUpWidgets?: LayoutWidget[];
  setIsManagingLayout?: React.Dispatch<React.SetStateAction<boolean>>;
  widgetRefetch?: () => void;
  scope: string;
  userDataRefetch?: () => void;
  refetchOrganizationData?: () => void;
}



const OrganizationOverview = forwardRef<GridStackHandle, OrganizationOverviewProps>(
  (
    {
      editingPhase,
      organization,
      loading,
      refetch,
      widget,
      setWidget,
      isManagingLayout,
      backUpWidgets,
      setIsManagingLayout,
      widgetRefetch,
      scope,
      userDataRefetch,
      refetchOrganizationData
    }: OrganizationOverviewProps,
    ref
  ) => {
    return (
      <div className=" mt-4">
        <GridStackExample userDataRefetch={userDataRefetch} scope={scope} widgetRefetch={widgetRefetch} ref={ref} backupWidget={backUpWidgets} setIsManagingLayout={setIsManagingLayout} isManageLayout={isManagingLayout} widgets={widget} setWidgets={setWidget} refetch={refetch} organization={organization} editingPhase={editingPhase} loading={loading} refetchOrganizationData={refetchOrganizationData} />
      </div>
    );
  });

export default OrganizationOverview;

// Styled components
export const StyledBox = styled('div')<{ editingPhase?: boolean }>(
  ({ theme, editingPhase }) => ({
    backgroundColor: editingPhase
      ? theme.CorporateTheme?.colors?.bannerBG
      : theme.CorporateTheme?.colors?.background,
    borderRadius: '5px',
    border: `1px solid ${theme.CorporateTheme?.colors?.border}`,
    boxShadow: '0px 2px 10px 0px #0000000d',
    marginBottom: '10px',
  })
);


export const StyledHr = styled('div')(({ theme }) => ({
  marginBottom: '10px',
  color: theme.CorporateTheme?.colors?.border,
  borderBottom: `0.5px solid ${theme.CorporateTheme?.colors?.border}`,
}));

export const StyledVr = styled.div`
  border-right: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
  color: ${({ theme }) => theme.CorporateTheme.colors.border};
  height: 50px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${CreateFormTheme.spacing.sm};
  cursor: pointer;
  font-weight: 500;
  color: ${CreateFormTheme.colors.placeHolder};

  input {
    margin: 0;
  }
`;


// Skeleton
export const SkeletonCell = styled.div`
  width: 100%;
  height: 37px;
  border-radius: 4px;
  background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
  background-size: 200% 100%;
  animation: shimmer 0.5s infinite;
  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
`;
